/**
 * Product gate for Voxcanon-only routes.
 *
 * ADR 0004: a host containing `voxcanon` is Voxcanon, anything else is
 * Lexicanon. `beforeLoad` throws the redirect this returns so a direct URL
 * on a Lexicanon host never renders gaming copy.
 */
import type { TProduct } from "@lexicanon/shared"
import { redirect } from "@tanstack/react-router"

export type TVoxcanonFallback = { to: "/" } | { to: "/meetings/$id"; params: { id: string } }

/** `null` when the product may render the page. Otherwise a redirect to throw. */
export function voxcanonOnlyRedirect(
  product: TProduct,
  fallback: TVoxcanonFallback,
): ReturnType<typeof redirect> | null {
  if (product === "voxcanon") return null
  if (fallback.to === "/") return redirect({ to: "/" })
  return redirect({ to: "/meetings/$id", params: { id: fallback.params.id } })
}
